import { authAPI } from "../../api/authAPI"
import { AUTHENTICATE, authenticateAC, DID_TRY_AL, logOutAC, LOG_IN, LOG_OUT, SIGN_UP } from "../actions/authActions"

const initialState = {
    email: null,
    token: null,
    userId: null,
    autoLogin: false,
    isFetching: false,
}

let timer

export const authReducer = (state = initialState, action) => {
    switch (action.type) {
        case AUTHENTICATE:
            return {
                ...state,
                token: action.token,
                userId: action.userId,
                email: action.email,
            }
        case SIGN_UP:
            return {
                ...state,
                token: action.token,
                userId: action.userId,
                email: action.email
            }
        case LOG_IN:
            return {
                ...state,
                token: action.token,
                userId: action.userId,
                email: action.email
            }
        case LOG_OUT:
            return initialState
        case DID_TRY_AL: {
            return {
                ...state,
                autoLogin: true
            }
        }
        default: return state
    }
}

export const authenticate = (token, userId, email, expiresIn) => dispatch => {
    dispatch(setLogoutTimer(expiresIn))
    dispatch(authenticateAC(token, userId, email))
}

export const logInOrSignUp = (action, email, password) => async (dispatch) => {
    let data
    try {
        if (action === 'signup') {
            data = await authAPI.signUp(email, password)
        } else {
            data = await authAPI.logIn(email, password)
        }

        dispatch(authenticate(data.accessToken, data.uid, data.email, parseInt(data.expiresIn) * 1000))
        const expirationTime = new Date().getTime() + parseInt(data.expiresIn) * 1000
        localStorage.setItem('userData', JSON.stringify({
            token: data.accessToken,
            userId: data.uid,
            email: data.email,
            expirationDate: new Date(expirationTime)
        }))
    } catch (e) {
        throw e
    }
}

export const logOut = () => async (dispatch) => {
    try {
        await authAPI.logOut()
        dispatch(logOutAC())
        localStorage.removeItem('userData')
        if (timer) {
            clearTimeout(timer)
        }
    } catch (e) {
        throw e
    }
}

const setLogoutTimer = (expiresIn) => dispatch => {
    timer = setTimeout(() => {
        dispatch(logOut())
    }, expiresIn)
}